export default __webpack_public_path__ + "img/tab2-1a172f4d.png";